/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import moment from 'moment'

export default {
    SET_HOURS_RENDERED_DATA_LOADING(state, value) {
        state.hoursRenderedDataLoading = value
    },
    SET_HOURS_RENDERED_DATA_LOADED(state, value) {
        state.hoursRenderedDataLoaded = value
    },
    SET_HOURS_RENDERED_DATA_ERROR(state, value) {
        state.hoursRenderedDataError = value
    },
    TEMP_TO_LIVE(state, item) {
        state.isProcessedUploadedSuccessfull = item
        // state.getAllLogHours = item
    },
    PROCESS_PAYROLL(state, item) {
        state.processPayroll = item
    },
    CLOSED_PAYROLL(state, item) {
        state.closedPayroll = item
    },
    GENERATE_REPORTS(state, item) {
        //console.log('state.generatereports')
        //console.log(item)
        state.generatereports = item
    },
    ADD_CREATEPAYROLL(state, item) {
        state.getAllCreatePayroll.unshift(item)
    },
    UPDATE_CREATEPAYROLL(state, item) {
        const index = state.getAllCreatePayroll.findIndex((e) => e.createPayrollId === item.createPayrollId)
        Object.assign(state.getAllCreatePayroll[index], item)
    },
    GET_ALL_CREATEPAYROLL(state, payload) {
        let p = payload
        let createPayroll = []
            p.forEach(d => {
                createPayroll.push(Object.assign(d, { payOutDate: moment(d.payOutDate).format('YYYY-MM-DD'),
                cutOffStartDate: moment(d.cutOffStartDate).format('YYYY-MM-DD'),
                cutOffEndDate: moment(d.cutOffEndDate).format('YYYY-MM-DD'),
                monthName: moment(d.monthName, 'M').format('MMMM')
                }))
            })
        state.getAllCreatePayroll = createPayroll

    },
    ADD_TEMPLOGHOURS(state, item) {

        state.uploadedLogHours = item
    },
    ADD_TEMPOVERTIMEHOURS(state, item) {
        state.uploadedOvertimeHours = item

    },
    ADD_TEMPEARNINGS(state, item) {
        state.uploadedEarnings = item

    },
    ADD_TEMPDEDUCTIONS(state, item) {
        state.uploadedDeductions = item

    },
    ADD_TEMPLOANS(state, item) {
        state.uploadedLoans = item

    },
    GET_ALL_LOGHOURS(state, item) {
        let logHours = []
        let earnings = []
        let deductions = []
        let loans = []
        item.forEach((u) => {
            const l = {
                absencesHours: u.absencesHours,
                addedManuallyBy: u.addedManuallyBy,
                addedManuallyOn: u.addedManuallyOn,
                basicpay: u.basicpay,
                createPayrollId: u.createPayrollId,
                efficiencyRate: u.efficiencyRate,
                extractedBy: u.extractedBy,
                extractedOn: u.extractedOn,
                hoursWorked: u.hoursWorked,
                isManuallyAdded: u.isManuallyAdded,
                lwopHours: u.lwopHours,
                tardinessHours: u.tardinessHours,
                undertimeHours: u.undertimeHours,
                hourlyRate: u.hourlyRate,
                uploadedBy: u.uploadedBy,
                uploadedOn: u.uploadedOn,
                userId: u.userId,
                user: u.user
            }
            logHours.push(l)

            u.employeeEarnings.forEach((e) => {
                earnings.push(e)
            })
            u.employeeDeductions.forEach((d) => {
                deductions.push(d)
            })
            u.employeeLoans.forEach((el) => {
                loans.push(el)
            })


        })
        state.getAllLogHours = logHours
        state.getAllEarnings = earnings
        state.getAllDeductions = deductions
        state.getAllLoans = loans
console.log('MUTATE')
console.log(state.getAllLogHours)

    },
    GET_ALL_LOGHOURSHISTORY(state, item) {
      let logHours = []
      let earnings = []
      let deductions = []
      let loans = []
      item.forEach((u) => {
          const l = {
              absencesHours: u.absencesHours,
              addedManuallyBy: u.addedManuallyBy,
              addedManuallyOn: u.addedManuallyOn,
              basicpay: u.basicpay,
              createPayrollId: u.createPayrollId,
              efficiencyRate: u.efficiencyRate,
              extractedBy: u.extractedBy,
              extractedOn: u.extractedOn,
              hoursWorked: u.hoursWorked,
              isManuallyAdded: u.isManuallyAdded,
              lwopHours: u.lwopHours,
              tardinessHours: u.tardinessHours,
              undertimeHours: u.undertimeHours,
              hourlyRate: u.hourlyRate,
              uploadedBy: u.uploadedBy,
              uploadedOn: u.uploadedOn,
              userId: u.userId,
              user: u.user
          }
          logHours.push(l)

          u.employeeEarnings.forEach((e) => {
              earnings.push(e)
          })
          u.employeeDeductions.forEach((d) => {
              deductions.push(d)
          })
          u.employeeLoans.forEach((el) => {
              loans.push(el)
          })


      })
      state.getAllLogHours = logHours
      state.getAllEarnings = earnings
      state.getAllDeductions = deductions
      state.getAllLoans = loans
  },
    GET_ALL_OVERTIME(state, item) {
        state.getAllOvertime = item
    },
    GET_ALL_EARNINGS(state, item) {
        state.getAllEarnings = item
    },
    GET_ALL_DEDUCTIONS(state, item) {
        state.getAllDeductions = item
    },
    GET_ALL_LOANS(state, item) {
        state.getAllLoans = item
    },
    UPDATE_EMPLOYEELOGHOURS(state, item) {
        // state.getAllLogHours = item
        const index = state.getAllLogHours.findIndex((e) => e.id === item.id)
        Object.assign(state.getAllLogHours[index], item)
    },
    ADD_EMPLOYEEOVERTIME(state, item) {
        state.getAllOvertime.unshift(item)
    },
    UPDATE_EMPLOYEEOVERTIME(state, item) {
        // state.getAllOvertime = item
        const index = state.getAllOvertime.findIndex((e) => e.id === item.id)
        Object.assign(state.getAllOvertime[index], item)
    },
    DELETE_EMPLOYEEOVERTIME(state, item) {
        const eventIndex = state.getAllOvertime.findIndex((e) => e.id === item)
        state.getAllOvertime.splice(eventIndex, 1)
    },
    ADD_EMPLOYEEEARNINGS(state, item) {
        state.getAllEarnings.unshift(item)
    },
    UPDATE_EMPLOYEEEARNINGS(state, item) {
        // state.getAllEarnings = item
        const index = state.getAllEarnings.findIndex((e) => e.id === item.id)
        Object.assign(state.getAllEarnings[index], item)
    },
    DELETE_EMPLOYEEEARNINGS(state, item) {
        const eventIndex = state.getAllEarnings.findIndex((e) => e.id === item)
        state.getAllEarnings.splice(eventIndex, 1)
    },
    ADD_EMPLOYEEDEDUCTIONS(state, item) {
        state.getAllDeductions.unshift(item)
    },
    UPDATE_EMPLOYEEDEDUCTIONS(state, item) {
        // state.getAllDeductions = item
        const index = state.getAllDeductions.findIndex((e) => e.id === item.id)
        Object.assign(state.getAllDeductions[index], item)
    },
    DELETE_EMPLOYEEDEDUCTIONS(state, item) {
        const eventIndex = state.getAllDeductions.findIndex((e) => e.id === item)
        state.getAllDeductions.splice(eventIndex, 1)
    },
    ADD_EMPLOYEELOANS(state, item) {
        state.getAllLoans.unshift(item)
    },
    UPDATE_EMPLOYEELOANS(state, item) {
        // state.getAllLoans = item
        const index = state.getAllLoans.findIndex((e) => e.id === item.id)
        Object.assign(state.getAllLoans[index], item)
    },
    DELETE_EMPLOYEELOANS(state, item) {
        const eventIndex = state.getAllLoans.findIndex((e) => e.id === item)
        state.getAllLoans.splice(eventIndex, 1)
    },
}
